<template>
  <div class="loginWrapper">
    <div class="containerSingleBox">
      <!--Login box -->
      <div class="loginBox background-white">
        <div class="logo">
          <img src="../../assets/images/up.svg" />
          <br />
          <br />
          <div v-if="!loading">
            <h2 v-if="this.newPasswordData === null && !this.resetComplete">
              {{ $t("forgotPasswordTitle") }}
            </h2>
            <h2 v-if="this.newPasswordData !== null && !this.resetComplete">
              {{ $t("resetPasswordTitle") }}
            </h2>
            <p
              class="lightGrey"
              v-if="this.newPasswordData === null && !this.resetComplete"
              v-html="$t('forgotPasswordMessageCompany')"
            ></p>
            <p
              class="lightGrey"
              v-if="
                this.newPasswordData !== null &&
                  !this.resetComplete &&
                  !this.registrationError
              "
              v-html="$t('resetPasswordMessageCompany')"
            ></p>
            <p class="loginError" v-if="this.registrationError !== null">
              {{ this.config.errors[this.registrationError.error_code] }}
            </p>
          </div>
        </div>

        <div
          class="loginForm"
          v-if="this.newPasswordData === null && this.resetComplete"
        >
          <form @submit.prevent="sendResetPasswordEmail">
            <!-- Begin congrats mail sent -->
            <div class="loginForm">
              <form @submit.prevent="completePasswordReset" align="center">
                <img src="../../assets/images/congrats.png" />

                <h2 align="center">{{ $t("successMessageTitle") }}</h2>
                <p align="center" class="lightGrey">
                  {{ $t("resetPasswordSuccessMessageCompany") }}
                </p>
                
                <input type="submit" value="CONFIRM" class="submitCompanies" />
              </form>
            </div>
            <!-- End congrats mail sent -->
          </form>
        </div>
        <div
        class="loginForm"
        v-if="this.newPasswordData === null && !this.resetComplete"
        >
        <form @submit.prevent="sendResetPasswordEmail">
          <div v-if="loading" class="loading">
            <img src="@/assets/images/loading.gif" class="w-100" />
          </div>
          <div v-else>
            <input
            type="text"
            :placeholder="$t('companyCodeOrEmailLabel')"
            id="input-CompanyCode"
            v-model="formData.companyCode"
            required
            @keyup="updateInputCharacters()"
            />
            <input
            type="number"
            :placeholder="$t('fiscalCodeOrCodeCompanyLabel')"
            id="input-passs-token"
            v-model="formData.passToken"
            required
            />
            <vue-turnstile @update="tokenCaptcha = $event" :site-key="getCaptchaKey()" ref="captcha" theme="light" class="d-flex justify-content-center my-4"/>
            
            <input
            type="submit"
            :value="[[$t('confirmButtonLabel')]]"
            variant="primary"
            class="submitCompanies"
            />
          </div>
        </form>
      </div>
      <div
      class="loginForm"
      v-if="this.newPasswordData !== null && !this.resetComplete"
      >
      <form @submit.prevent="resetCustomerPassword">
        <!-- change password form -->
        <div v-if="this.newPasswordData !== null && !this.resetComplete">
          <div class="password">
            <input :placeholder="$t('passwordField')" v-model="newPasswordData.new_password"
            @input="validatePassword" required :type="showNewPassword ? 'text' : 'password'" />
            <i v-on:click="showNewPassword = !showNewPassword">
              <font-awesome-icon :icon="showNewPassword ? 'eye-slash' : 'eye'" />
              
            </i>
          </div>
          <div class="password">
            <input :placeholder="$t('confirmPasswordField')" required :style="confirmPasswordStyle"
            @input="validatePassword" v-model="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" />
            <i v-on:click="showConfirmPassword = !showConfirmPassword">
              <font-awesome-icon :icon="showConfirmPassword ? 'eye-slash' : 'eye'" />
              
            </i>
          </div>
          <vue-turnstile @update="tokenCaptcha2 = $event"  ref="captcha2" v-model="tokenCaptcha2" :site-key="getCaptchaKey()" theme="light" class="d-flex justify-content-center mb-2"/>
          <input
          type="submit"
          :value="[[$t('confirmButtonLabel')]]"
          variant="primary"
          class="submitCompanies"
          />
        </div>
      </form>
    </div>
    <!-- Begin congrats -->
    <div
    class="loginForm"
    v-if="this.newPasswordData != null && this.resetComplete"
    >
    <form @submit.prevent="completePasswordReset" align="center">
      <img src="../../assets/images/congrats.png" />

            <h2 align="center">{{ $t("successMessageTitle") }}</h2>
            <p align="center" class="lightGrey">
              {{ $t("resetPasswordSuccessMessage") }}
            </p>
            <input type="submit" value="CONFIRM" class="submitCompanies" />
          </form>
        </div>
        <!-- End congrats -->
      </div>
      <!--End Login box -->
    </div>
  </div>
</template>

<script>
import validator from "../../plugins/fieldValidation";
import utils from "../../plugins/utils.js";
import httpCommon from "../../http/http-common.js";
import VueTurnstile from "@/components/captcha/Turnstile.vue";

export default {
  name: "forgot_password_company",
  props: {
    msg: String
  },
  components: {VueTurnstile },
  data() {
    return {
      formData: {
        companyCode: "",
        passToken: ""
      },
      token: null,
      registrationError: null,
      showNewPassword: false,
      showConfirmPassword: false,
      resetComplete: false,
      newPasswordData: null,
      confirmPassword: "",
      category: "",
      config: null,
      loading: false,
      tokenCaptcha: null,
      tokenCaptcha2: null
    };
  },
  methods: {
    loginCustomer() {
      let passData = {
        username: this.formData.companyCode,
        email: this.formData.companyCode,
        pass_token: this.formData.passToken
      };
      this.loading = true;
      httpCommon.companyService
        .userCheckForPasswordReset(passData, this.token)
        .then(function(response) {
          // handle success
          return response;
        })
        .catch(error => {
          return error.response;
        })
        .then(response => {
          this.loading = false;
          this.resetComplete = false;
          if (response.status == 200) {
            this.resetComplete = true;
            // do congrats
          // } else if (response.status == 400) {
          //   this.registrationError = response.data;
          } else {
            this.registrationError = {
              error_code: "ISSS",
              description: response.code
            };
          }
        });
    },
    sendResetPasswordEmail() {
      this.getTokenForValidateCredentials();
    },
    getTokenForValidateCredentials(resetCode) {
      httpCommon.companyService
        .requestTokenForRegistration("clientopen", resetCode ? this.tokenCaptcha2 : this.tokenCaptcha)
        .then(function(response) {
          // handle success
          return response.data;
        })
        .then(data => {
          this.token = data.access_token;
          // validate client credentials
          if (resetCode) {
            this.checkPasswordResetCode(resetCode);
          } else {
            if (this.newPasswordData === null) {
              this.loginCustomer();
            } else {
              this.resetCustomerPassword();
            }
          }
        })
        .catch(error => {
          // handle error
        });
    },
    completePasswordReset() {
      this.registrationError = null;
      this.formData = null;
      this.resetComplete = false;

      this.$router.push({
        name: "login",
        params: { loginUserSelected: false }
      });
    },
    validatePassword() {
      // this.validPassword = 
      validator.validatePassword(
        this.newPasswordData.new_password,
        this.confirmPassword
      );
    },
    resetCustomerPassword() {
      let passwordData = {
        auth_password: this.newPasswordData.reset_code,
        new_password: this.newPasswordData.new_password,
        password_id: 1
      };
      this.registrationError = null;
      httpCommon.companyService
        .companyPasswordReset(passwordData, this.token)
        .then(function(response) {
          // handle success
          return response;
        })
        .catch(error => {
          // handle error
          this.registrationError = error.response.data;
          return error.response;
        })
        .then(response => {
          if (response.status == 200) {
            this.registrationError = null;
            this.resetComplete = true;
            // do congrats
          } else if (response.status == 400) {
            this.registrationError = response.data;
          } else {
            this.registrationError = {
              error_code: "ISSS",
              description: "Server error"
            };
          }
        });
    },
    checkPasswordResetCode(resetCode) {
      this.newPasswordData = {
        reset_code: resetCode,
        new_password: ""
      };
      httpCommon.companyService
        .userResetCodeCheck("resetCode=" + resetCode, this.token)
        .then(function(response) {
          // handle success
          return response;
        })

        .then(response => {
          if (response.status == 200) {
            this.passwordData = {
              password_id: 1,
              auth_password: resetCode
            };
            // do congrats
          } else if (response.status == 400) {
            this.registrationError = response.data.error_code;
          } else {
            this.registrationError = {
              error_code: "ISSS",
              description: "Server error"
            };
          }
        })
        .catch(error => {
          // handle error
          this.registrationError = error.response.data;
          return error.response;
        });
    },
    confirmPasswordStyle() {
      return this.confirmPassword === ""
        ? ""
        : this.newPasswordData.new_password === this.confirmPassword
        ? ""
        : "outline-color: #ff0000a6;";
    },
    onlyAlphaNumericCharacters(variable) {
      if (/^[a-zA-Z0-9@.]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(/[&\/\\|`#\[\]\,+=()$~%'":*!?<>{}]/g, "");
      }
    },
    updateInputCharacters() {
      this.formData.companyCode = this.onlyAlphaNumericCharacters(
        this.formData.companyCode
      );
      this.$forceUpdate();
    }
  },
  mounted() {
    if (this.$gtm) {
      this.$gtm.enable(false);
    }
    let resetCode = utils.getUrlParam("resetCode");
    this.category = utils.getUrlParam("category");

    if (resetCode !== null) {
      this.getTokenForValidateCredentials(resetCode);
    } else {
      this.newPasswordData = null;
    }
    if (!sessionStorage.getItem("mobile_jsonFile")) {
      httpCommon.commonsService
        .getConfigFile(localStorage.language, "mobile")
        .then(function(response) {
          return response;
        })
        .then(data => {
          this.config = JSON.parse(
            sessionStorage.getItem("mobile_jsonFile")
          );
        });
    } else {
      this.config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
    }
  }
};
</script>
<style scoped src="@/assets/styles/login.css"></style>
